import React from 'react'
import EstablishmentsListProvider from 'context/establishments/EstablishmentsList';
import OnSelectMenuProvider from 'context/general/OnSelectMenu';
import CheckoutProvider from 'context/checkout/Checkout';
import EstablishmentProvider from 'context/establishments/Establishment';
import EstablishmentFilterProvider from 'context/establishments/EstablishmentFilter';
import EstablishmentsNearListallProvider from 'context/establishments/EstablishmentsNearListAll';
import EstablishmentsNearToYouProvider from 'context/establishments/EstablishmentsNearToYou';
import CollapseProvider from 'context/general/Collapse';
import EventProvider from 'context/events/Event';
import EventsListProvider from 'context/events/EventsList';
import EventFilterProvider from 'context/events/EventFilter';
import FavoritedEventsProvider from 'context/events/FavoritedEvents';
import TagsProvider from 'context/events/Tags';
import EventsNearToYouProvider from 'context/events/EventsNearToYou';
import BackButtonCollapseProvider from 'context/general/BackButtonCollapse';
import NearListAllProvider from 'context/events/NearListAll';
import EstablishmentTagsProvider from 'context/establishments/EstablishmentTags';
import UserLocaleProvider from 'context/user/UserLocale';
import UserLocationProvider from 'context/user/UserLocation';
import CurrentLocationProvider from 'context/user/CurrentLocation';
import ShowLocationModalProvider from 'context/general/ShowLocationModal';
import EventDetailModalProvider from 'context/events/EventDetailModal';
import MainCollapseProvider from 'context/main/MainCollapse';
import HighlightedEventProvider from 'context/events/HighlightedEvent';
import { ShowLoginModalProvider } from 'context/general/ShowLoginModal';
import ShowSearchOverlayProvider from 'context/general/ShowSearchOverlay';

export default function HomeWrapper({ children }) {
    return (
        <ShowSearchOverlayProvider>
        <ShowLoginModalProvider>
        <OnSelectMenuProvider>
            <CollapseProvider>
                <EventsListProvider>
                    <EventProvider>
                        <EventFilterProvider>
                            <FavoritedEventsProvider>
                            <TagsProvider>
                                <EventsNearToYouProvider>
                                    <NearListAllProvider>
                                        <BackButtonCollapseProvider>
                                            <EstablishmentsListProvider>
                                                <CheckoutProvider>
                                                    <EstablishmentProvider>
                                                        <EstablishmentFilterProvider>
                                                            <EstablishmentsNearListallProvider>
                                                                <EstablishmentsNearToYouProvider>
                                                                    <EstablishmentTagsProvider>
                                                                        <UserLocaleProvider>
                                                                            <UserLocationProvider>
                                                                                <CurrentLocationProvider>
                                                                                    <ShowLocationModalProvider>
                                                                                        <EventDetailModalProvider>
                                                                                            <MainCollapseProvider>
                                                                                                <HighlightedEventProvider>

                                                                                                    {children}

                                                                                                </HighlightedEventProvider>
                                                                                            </MainCollapseProvider>
                                                                                        </EventDetailModalProvider>
                                                                                    </ShowLocationModalProvider>
                                                                                </CurrentLocationProvider>
                                                                            </UserLocationProvider>
                                                                        </UserLocaleProvider>
                                                                    </EstablishmentTagsProvider>
                                                                </EstablishmentsNearToYouProvider>
                                                            </EstablishmentsNearListallProvider>
                                                        </EstablishmentFilterProvider>
                                                    </EstablishmentProvider>
                                                </CheckoutProvider>
                                            </EstablishmentsListProvider>
                                        </BackButtonCollapseProvider>
                                    </NearListAllProvider>
                                </EventsNearToYouProvider>
                            </TagsProvider>
                            </FavoritedEventsProvider>
                        </EventFilterProvider>
                    </EventProvider>
                </EventsListProvider>
            </CollapseProvider>
        </OnSelectMenuProvider>
        </ShowLoginModalProvider>
        </ShowSearchOverlayProvider>
    )
}
